import React from 'react'

export default function Plus1(props) {
    let { className, click } = props;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" className={className} onClick={click}>
            <path d="M1 6.88281L12.7676 6.88281" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.88281 12.7734L6.88281 1.00562" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
